import React from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import * as extract from 'extractFromState';
import * as sensitiveData from 'constants/sensitiveDataTypes';
import * as listTypes from 'constants/infoPanelTypes';
import ProtectedData from 'components/common/ProtectedData/ProtectedData';
import { getOrderingSystem } from 'selectors/tools';
import { setAlertManagerType } from 'actions/tools/ToolActions';
import {
  eraseRecommendationRegExFromTextInput,
  trackCommerceCloseWithNoRecommendations,
} from 'actions/CommerceWizardActions';
import { setCenterPaneExtraInfoPanelActive } from 'actions';
import { getMappedValueFromOrderOrItem } from 'util/decisionTreeUtil';
import { formatOrderDateToLocalTime } from 'util/formatUtil';
import AlertCenterPanel from 'components/AlertCenterPanel/AlertCenterPanel';
import Loading from 'components/LoadingComponent/LoadingComponent';
import PartnerInfo from './PartnerInfo/PartnerInfo';
import CommerceWizard from './CommerceWizard/CommerceWizard';
import CWBreadcrumb from './CommerceWizard/CWBreadcrumb/CWBreadcrumb';
import { twoBtnPopupCreator } from 'components/popups/ConfirmPopup/helper';
import { trackPartnerInfoButtonClick } from '../../analytics/buttonEventAnalytics';
import { CustomerContext } from './CustomerContext';
import {
  Container,
  CenterPanelWrapper,
  RelativeWrapper,
  Divider,
  Section,
  CustomerSection,
  HeaderSection,
  MiniSection,
  InfoPanel,
  InfoPanelContent,
  InfoPanelNavigation,
  CommerceWizardNavigation,
  NavigationTab,
  InfoPanelHeader,
  InfoPanelSubheader,
  InfoPanelRow,
  ItemRow,
  ItemInfoWrapper,
  CenterPanelFadeBackground,
  Table,
  Row,
  HeaderRow,
  TableData,
  TableHeader,
  CommerceIcon,
  TableHeaderSection,
  TableBodySection,
} from './CenterInfoPanel.styles';

export class CenterInfoPanel extends React.Component {
  state = {
    listMode: false,
    selectedItemIdx: null,
    loading: false,
    orderInfo: null,
  };

  getItemsFromOrder() {
    const { orderingSystem, selectedOrder } = this.props;
    switch (orderingSystem) {
      case 'shopify':
        return get(selectedOrder, 'line_items', []);
      default:
        return [];
    }
  }

  getCurrentTag() {
    const { tagPathArray, currentlyStoredTag } = this.props;
    if (currentlyStoredTag) {
      return currentlyStoredTag.split(' -- ').join(' - ');
    } else if (tagPathArray.length) {
      return tagPathArray.join(' - ');
    }

    return 'No tag';
  }

  getFieldFromSelectedOrder(field) {
    const { selectedOrder, orderingSystem } = this.props;
    if (selectedOrder) {
      return getMappedValueFromOrderOrItem(selectedOrder, field, orderingSystem);
    }

    return null;
  }

  mentionedOrderSectionActive() {
    const { mentionedOrderIds, selectedOrder, infoPanelActive, orderingSystem } = this.props;
    if (selectedOrder) {
      const selectedOrderNumber = getMappedValueFromOrderOrItem(selectedOrder, 'orderNumber', orderingSystem);
      if (selectedOrderNumber) {
        return infoPanelActive && mentionedOrderIds.includes(selectedOrderNumber.toString());
      }

      return false;
    }

    return false;
  }

  subscriptionSectionActive() {
    const { infoPanelActive, listType } = this.props;

    return infoPanelActive && listType === listTypes.SUBSCRIPTIONS ? true : false;
  }

  recentOrderSectionActive() {
    const { mentionedOrderIds, selectedOrder, infoPanelActive, orderingSystem, listType } = this.props;
    if (selectedOrder) {
      const selectedOrderNumber = getMappedValueFromOrderOrItem(selectedOrder, 'orderNumber', orderingSystem);
      if (selectedOrderNumber) {
        return infoPanelActive && !mentionedOrderIds.includes(selectedOrderNumber.toString());
      }
    }

    return infoPanelActive && listType === listTypes.ORDERS ? true : false;
  }

  partnerInfoSectionActive() {
    const { infoPanelActive, listType } = this.props;

    return infoPanelActive && listType === listTypes.PARTNER_INFO ? true : false;
  }

  commerceSectionActive() {
    const { infoPanelActive, listType } = this.props;

    return infoPanelActive && (listType === listTypes.COMMERCE || listType === listTypes.COMMERCE_ON_DEMAND);
  }

  async handleClickOrderNumber(order) {
    const { setCenterPaneInfoPanelActive } = this.props;
    // clear selected items, clear listMode
    this.setState({
      listMode: false,
      selectedItemIdx: null,
    });
    // clear alerts
    this.props.setAlertManagerType(null);
    // activate popout panel
    setCenterPaneInfoPanelActive(true, order, null, listTypes.ORDERS);
  }

  handleClickPartnerInfo() {
    const { setCenterPaneInfoPanelActive } = this.props;
    if (this.partnerInfoClickable()) {
      if (this.partnerInfoSectionActive()) {
        setCenterPaneInfoPanelActive(false, null);
      } else {
        // clear selected items, clear listMode
        this.setState({
          listMode: false,
          selectedItemIdx: null,
        });
        // clear alerts
        this.props.setAlertManagerType(null);
        // activate popout panel
        setCenterPaneInfoPanelActive(true, null, null, listTypes.PARTNER_INFO);
        trackPartnerInfoButtonClick();
      }
    }
  }

  handleClickCommerceSection() {
    if (this.props.previouslyRecommendedProducts) {
      if (this.commerceSectionActive()) {
        this.props.setCenterPaneInfoPanelActive(false, null);
      } else {
        this.props.setAlertManagerType(null);
        this.props.setCenterPaneInfoPanelActive(true, null, null, listTypes.COMMERCE_ON_DEMAND);
      }
    }
  }

  handleClickRecentOrderSection() {
    if (this.recentOrderSectionActive()) {
      this.props.setCenterPaneInfoPanelActive(false, null);
    } else {
      this.setState({ listMode: true });
      this.props.setAlertManagerType(null);
      this.props.setCenterPaneInfoPanelActive(true, null, null, listTypes.ORDERS);
    }
  }

  handleCloseClick() {
    if (this.props.listType !== listTypes.COMMERCE) {
      return this.props.setCenterPaneInfoPanelActive(false);
    }
  }

  renderTrackingNumbers(item) {
    const { selectedOrder, orderingSystem } = this.props;
    switch (orderingSystem) {
      case 'shopify':
        if (selectedOrder && selectedOrder.fulfillments) {
          const { id } = item;
          const fulfillmentWithItem = selectedOrder.fulfillments.find((fulfillment) => {
            const lineItems = fulfillment.line_items || fulfillment.shipmentItems || [];

            return lineItems.some((elem) => elem.id === id || String(elem.lineItemKey) === String(id));
          });
          // collect all nums from nested data
          const trackingNumber = get(fulfillmentWithItem, 'tracking_number', null);
          const trackingUrl = get(fulfillmentWithItem, 'tracking_url', null);
          // determine if idx label needed
          if (trackingNumber && trackingUrl) {
            return (
              <ItemRow key={trackingNumber}>
                <label>Tracking Number</label>
                <p>
                  <a href={trackingUrl} target="_blank" rel="noopener noreferrer">
                    {trackingNumber}
                  </a>
                </p>
              </ItemRow>
            );
          } else if (trackingNumber) {
            return (
              <ItemRow key={trackingNumber}>
                <label>Tracking Number</label>
                <p>{trackingNumber}</p>
              </ItemRow>
            );
          }

          return null;
        }

        return null;
      default:
        return null;
    }
  }

  getFrequency(fieldName) {
    const { selectedSubscription } = this.props;
    const frequency = get(selectedSubscription, fieldName, null);
    if (frequency) {
      return `${frequency} ${get(selectedSubscription, 'order_interval_unit', '')}${frequency > 1 ? 's' : ''}`;
    }

    return 'Not available';
  }

  onItemHeaderClick(idx) {
    if (idx !== this.state.selectedItemIdx) {
      this.setState({ selectedItemIdx: idx });
    } else if (idx === this.state.selectedItemIdx) {
      this.setState({ selectedItemIdx: null });
    }
  }

  renderList() {
    const { recentOrders, orderingSystem, partnerName, recentSubscriptions, listType } = this.props;
    if (listType === listTypes.ORDERS) {
      return (
        <>
          <InfoPanelHeader>
            <h1>Customer Orders</h1>
            <p>{`These are all ${partnerName} orders made by this customer`}</p>
          </InfoPanelHeader>
          <Table>
            <TableHeaderSection>
              <HeaderRow>
                <TableHeader>ORDER #</TableHeader>
                <TableHeader center={true}>DATE</TableHeader>
              </HeaderRow>
            </TableHeaderSection>
            <TableBodySection>
              {recentOrders.map((order, idx) => {
                const dateString = this.formatOrderOrSubscriptionDate(
                  getMappedValueFromOrderOrItem(order, 'createdAt', orderingSystem)
                );
                const orderNumberString = getMappedValueFromOrderOrItem(order, 'orderNumber', orderingSystem);

                return (
                  <Row key={`recent_order_${idx}`} even={idx % 2 === 0}>
                    <TableData dark={true} bold={true} onClick={() => this.handleClickOrderNumber(order)}>
                      {orderNumberString}
                    </TableData>
                    <TableData center={true}>{dateString}</TableData>
                  </Row>
                );
              })}
            </TableBodySection>
          </Table>
        </>
      );
    }

    return (
      <>
        <InfoPanelHeader>
          <h1>Customer Subscriptions</h1>
          <p>{`These are all ${partnerName} subscriptions made by this customer`}</p>
        </InfoPanelHeader>
        <Table>
          <TableHeaderSection>
            <HeaderRow>
              <TableHeader>PRODUCT</TableHeader>
              <TableHeader center={true}>DATE</TableHeader>
            </HeaderRow>
          </TableHeaderSection>
          <TableBodySection>
            {recentSubscriptions.map((subscription, idx) => (
              <Row key={`recent_subscription_${idx}`} even={idx % 2 === 0}>
                <TableData
                  dark={true}
                  onClick={() => {
                    this.setState({ listMode: false });
                    this.props.setCenterPaneInfoPanelActive(true, null, subscription, listTypes.SUBSCRIPTIONS);
                  }}
                >
                  {get(subscription, 'product_title', 'undefined')}
                </TableData>
                <TableData center={true}>
                  {this.formatOrderOrSubscriptionDate(get(subscription, 'created_at', null), orderingSystem)}
                </TableData>
              </Row>
            ))}
          </TableBodySection>
        </Table>
      </>
    );
  }

  renderItemsSection() {
    const { selectedOrder, orderingSystem } = this.props;
    const { selectedItemIdx } = this.state;

    return (
      <>
        {selectedOrder &&
          this.getItemsFromOrder().map((item, idx) => {
            const isSelected = idx === selectedItemIdx;

            return (
              <>
                <InfoPanelRow menuActive={isSelected} clickable={true} onClick={() => this.onItemHeaderClick(idx)}>
                  <label>{`Item ${idx + 1}`}</label>
                  {isSelected ? (
                    <p>
                      Hide <img src="/images/up-arrow-blue.svg" alt="arrow" />
                    </p>
                  ) : (
                    <p>
                      Show <img src="/images/down-arrow-gray.svg" alt="arrow" />
                    </p>
                  )}
                </InfoPanelRow>
                {isSelected && (
                  <ItemInfoWrapper>
                    <ItemRow>
                      <label>Name</label>
                      <p>{getMappedValueFromOrderOrItem(item, 'name', orderingSystem) || 'Not available'}</p>
                    </ItemRow>
                    <ItemRow>
                      <label>Price</label>
                      <p>
                        {(getMappedValueFromOrderOrItem(item, 'price', orderingSystem) &&
                          `$${parseFloat(getMappedValueFromOrderOrItem(item, 'price', orderingSystem)).toFixed(2)}`) ||
                          'Not available'}
                      </p>
                    </ItemRow>
                    <ItemRow>
                      <label>Quantity</label>
                      <p>
                        {parseInt(getMappedValueFromOrderOrItem(item, 'quantity', orderingSystem)) || 'Not available'}
                      </p>
                    </ItemRow>
                    {this.renderTrackingNumbers(item)}
                  </ItemInfoWrapper>
                )}
              </>
            );
          })}
      </>
    );
  }

  formatOrderOrSubscriptionDate = (dateString) => {
    if (!dateString) {
      return '';
    }

    let { orderingSystem } = this.props;

    return formatOrderDateToLocalTime(dateString, orderingSystem);
  };

  renderOrderOrSubscriptionSummary() {
    const { selectedOrder, selectedSubscription } = this.props;
    const dateString = this.formatOrderOrSubscriptionDate(this.getFieldFromSelectedOrder('createdAt'));

    if (selectedOrder) {
      return (
        <>
          <InfoPanelHeader>
            <h1>Order Summary</h1>
          </InfoPanelHeader>
          <InfoPanelSubheader>
            <h2>Customer</h2>
          </InfoPanelSubheader>
          <InfoPanelRow>
            <label>Customer name</label>
            <p>
              {(this.getFieldFromSelectedOrder('fullName') && (
                <ProtectedData
                  data={this.getFieldFromSelectedOrder('fullName')}
                  dataType={sensitiveData.fullName}
                  component={'CenterInfoPanel'}
                  noPlaceholder={true}
                  lockSize={'12px'}
                />
              )) ||
                'Not available'}
            </p>
          </InfoPanelRow>
          <InfoPanelRow>
            <label>Customer email</label>
            <p>
              {(this.getFieldFromSelectedOrder('email') && (
                <ProtectedData
                  data={this.getFieldFromSelectedOrder('email')}
                  dataType={sensitiveData.email}
                  component={'CenterInfoPanel'}
                  noPlaceholder={true}
                  lockSize={'12px'}
                />
              )) ||
                'Not available'}
            </p>
          </InfoPanelRow>
          <InfoPanelSubheader>
            <h2>Order</h2>
          </InfoPanelSubheader>
          <InfoPanelRow>
            <label>Order number</label>
            <p>{this.getFieldFromSelectedOrder('orderNumber') || 'Not available'}</p>
          </InfoPanelRow>
          <InfoPanelRow>
            <label>Ordered at</label>
            <p>{dateString || 'Not available'}</p>
          </InfoPanelRow>
          <InfoPanelRow>
            <label>Price</label>
            <p>
              {(this.getFieldFromSelectedOrder('totalPrice') &&
                `$${parseFloat(this.getFieldFromSelectedOrder('totalPrice')).toFixed(2)}`) ||
                'Not available'}
            </p>
          </InfoPanelRow>
          <InfoPanelRow>
            <label>Total tax</label>
            <p>
              {(this.getFieldFromSelectedOrder('totalTax') &&
                `$${parseFloat(this.getFieldFromSelectedOrder('totalTax')).toFixed(2)}`) ||
                'Not available'}
            </p>
          </InfoPanelRow>
          {this.renderItemsSection()}
        </>
      );
    } else if (selectedSubscription) {
      const isPrepaid =
        selectedSubscription['charge_interval_frequency'] !== selectedSubscription['order_interval_frequency'];

      return (
        <>
          <InfoPanelHeader bottomPadding={'50px'}>
            <h1>Subscription Summary</h1>
          </InfoPanelHeader>
          <InfoPanelRow>
            <label>Product</label>
            <p>{get(selectedSubscription, 'product_title', 'Not available')}</p>
          </InfoPanelRow>
          <InfoPanelRow>
            <label>Status</label>
            <p>{get(selectedSubscription, 'status', 'Not available')}</p>
          </InfoPanelRow>
          <InfoPanelRow>
            <label>Type</label>
            <p>{isPrepaid ? 'Prepaid' : 'Pay-as-you-go'}</p>
          </InfoPanelRow>
          <InfoPanelRow>
            <label>Created At</label>
            <p>
              {get(selectedSubscription, 'created_at', null)
                ? this.formatOrderOrSubscriptionDate(get(selectedSubscription, 'created_at', null))
                : 'Not available'}
            </p>
          </InfoPanelRow>
          <InfoPanelRow>
            <label>Next charge</label>
            <p>
              {get(selectedSubscription, 'next_charge_scheduled_at', null)
                ? this.formatOrderOrSubscriptionDate(get(selectedSubscription, 'next_charge_scheduled_at', null))
                : 'Not available'}
            </p>
          </InfoPanelRow>
          <InfoPanelRow>
            <label>Charge Frequency</label>
            <p>{this.getFrequency('charge_interval_frequency')}</p>
          </InfoPanelRow>
          <InfoPanelRow>
            <label>Order Frequency</label>
            <p>{this.getFrequency('order_interval_frequency')}</p>
          </InfoPanelRow>
          <InfoPanelRow>
            <label>Sku</label>
            <p>{get(selectedSubscription, 'sku', null) ? get(selectedSubscription, 'sku', null) : 'Not available'}</p>
          </InfoPanelRow>
        </>
      );
    }

    return null;
  }

  partnerInfoClickable() {
    return this.props.partnerInfo && this.props.partnerInfo.length;
  }

  getInfoPanelContent() {
    const { listMode, loading } = this.state;

    if (loading) {
      return <Loading />;
    } else if (this.commerceSectionActive()) {
      return <CommerceWizard />;
    } else if (this.partnerInfoSectionActive()) {
      return <PartnerInfo />;
    }

    return listMode ? this.renderList() : this.renderOrderOrSubscriptionSummary();
  }

  renderPartnerInfoArrow() {
    if (this.partnerInfoClickable()) {
      return this.partnerInfoSectionActive() ? (
        <img src="/images/sideways-arrow-white.svg" alt="open" />
      ) : (
        <img src="/images/sideways-arrow-gray.svg" alt="open" />
      );
    }

    return null;
  }

  getHeaderText() {
    switch (this.props.listType) {
      case listTypes.ORDERS:
        return 'LIST ALL ORDERS';
      case listTypes.SUBSCRIPTIONS:
        return 'ALL SUBSCRIPTIONS';
      default:
        return null;
    }
  }

  handleCloseInfoPanel() {
    this.props.setCenterPaneInfoPanelActive(false, null);
  }

  handleSectionClick(func) {
    if (this.props.listType === listTypes.COMMERCE) {
      return twoBtnPopupCreator({
        content: {
          main: `You have not recommended a product.`,
          subText: [`Are you sure you want to leave?`],
          iconPath: '/images/green-alert-bell.svg',
        },
        btnConfig: {
          dismiss: 'Stay',
          confirm: 'Leave',
        },
        onConfirm: () => {
          this.props.eraseRecommendationRegExFromTextInput();
          this.props.trackCommerceCloseWithNoRecommendations();
          func();
        },
      });
    }

    func();
  }

  renderInfoPanelNavigation() {
    const { selectedOrder, selectedSubscription, listType, commerceWizardPath = [] } = this.props;
    const { listMode } = this.state;
    const summaryLabel = listType === listTypes.ORDERS ? 'ORDER SUMMARY' : 'SUMMARY';

    switch (listType) {
      case listTypes.ORDERS:
      case listTypes.SUBSCRIPTIONS:
        return (
          <InfoPanelNavigation>
            {(selectedOrder || selectedSubscription) && (
              <NavigationTab selected={!listMode} onClick={() => this.setState({ listMode: false })}>
                {summaryLabel}
              </NavigationTab>
            )}
            <NavigationTab selected={listMode} onClick={() => this.setState({ listMode: true })}>
              {this.getHeaderText()}
            </NavigationTab>
            <img
              onClick={() => this.handleSectionClick(() => this.handleCloseInfoPanel())}
              src="/images/close-x-small.svg"
              alt="open"
            />
          </InfoPanelNavigation>
        );
      case listTypes.COMMERCE:
      case listTypes.COMMERCE_ON_DEMAND:
        return (
          <>
            <CommerceWizardNavigation shouldDisplayText={commerceWizardPath.length}>
              <h2>PRODUCT SUGGESTION</h2>
              <img
                onClick={() => this.handleSectionClick(() => this.handleCloseInfoPanel())}
                src="/images/close-x-small.svg"
                alt="open"
              />
            </CommerceWizardNavigation>
            <CWBreadcrumb />
          </>
        );
      default:
        return null;
    }
  }

  renderInfoPanel() {
    const { infoPanelActive, listType } = this.props;

    return (
      <InfoPanel disableScroll={listType === listTypes.COMMERCE} active={infoPanelActive}>
        <InfoPanelContent>
          {this.renderInfoPanelNavigation()}
          {this.getInfoPanelContent()}
        </InfoPanelContent>
      </InfoPanel>
    );
  }

  render() {
    const {
      customerName,
      selectedTicketId,
      selectedTicket,
      recentOrders,
      mentionedOrders,
      orderingSystem,
      recentSubscriptions,
      partnerName,
      brandName,
      toolsMaskingActive,
      previouslyRecommendedProducts,
    } = this.props;
    const mentionedOrdersExist = !!mentionedOrders.length;
    const recentOrdersToDisplay = !!recentOrders.length && recentOrders.slice(0, 3);
    const recentSubscriptionsToDisplay = !!recentSubscriptions.length && recentSubscriptions.slice(0, 3);

    return (
      <>
        <Container>
          <CenterPanelWrapper>
            {partnerName && (
              <HeaderSection
                clickable={this.partnerInfoClickable()}
                onClick={() => this.handleSectionClick(() => this.handleClickPartnerInfo())}
                highlight={this.partnerInfoSectionActive()}
              >
                <h1>{brandName ? brandName : partnerName}</h1>
                {this.renderPartnerInfoArrow()}
              </HeaderSection>
            )}
            {selectedTicket && selectedTicket.simplrTicketNumber && (
              <Section>
                <label> TICKET #</label>
                <p>{selectedTicket.simplrTicketNumber}</p>
              </Section>
            )}
            <RelativeWrapper>
              <CustomerSection
                clickable={!!previouslyRecommendedProducts}
                highlight={this.commerceSectionActive()}
                onClick={() => this.handleClickCommerceSection()}
              >
                <div>
                  <label>CUSTOMER</label>
                  <p>{customerName || 'Unknown'}</p>
                </div>
                {!!previouslyRecommendedProducts && (
                  <CommerceIcon>
                    <img src="/images/commerce/commerce-icon.svg" alt="commerce" />
                    <img src="/images/sideways-arrow-white.svg" alt="open" />
                  </CommerceIcon>
                )}
              </CustomerSection>
            </RelativeWrapper>
            {selectedTicketId && (
              <Section breakWord={true}>
                <label>TAG</label>
                <p>{this.getCurrentTag()}</p>
              </Section>
            )}
            <Divider />
            {mentionedOrdersExist && (
              <RelativeWrapper>
                <Section
                  clickable={mentionedOrdersExist}
                  highlight={this.mentionedOrderSectionActive()}
                  length={mentionedOrders.length}
                >
                  <label>{mentionedOrders.length > 1 ? 'MENTIONED ORDERS' : 'MENTIONED ORDER'}</label>
                  {mentionedOrders.map((order) => (
                    <p
                      key={`mentioned_order_number_${getMappedValueFromOrderOrItem(
                        order,
                        'orderNumber',
                        orderingSystem
                      )}`}
                      onClick={() => this.handleClickOrderNumber(order)}
                    >
                      {getMappedValueFromOrderOrItem(order, 'orderNumber', orderingSystem)}
                    </p>
                  ))}
                  {this.mentionedOrderSectionActive() ? (
                    <img src="/images/sideways-arrow-white.svg" alt="open" />
                  ) : (
                    <img src="/images/sideways-arrow-gray.svg" alt="open" />
                  )}
                </Section>
              </RelativeWrapper>
            )}
            {recentOrdersToDisplay && !mentionedOrdersExist && (
              <RelativeWrapper>
                <MiniSection
                  clickable={true}
                  highlight={this.recentOrderSectionActive()}
                  onClick={() => this.handleSectionClick(() => this.handleClickRecentOrderSection())}
                >
                  <label>RECENT ORDERS</label>
                  {this.recentOrderSectionActive() ? (
                    <img src="/images/sideways-arrow-white.svg" alt="open" />
                  ) : (
                    <img src="/images/sideways-arrow-gray.svg" alt="open" />
                  )}
                </MiniSection>
              </RelativeWrapper>
            )}
            {recentSubscriptionsToDisplay && (
              <RelativeWrapper>
                <MiniSection>
                  <label>SUBSCRIPTIONS</label>
                  {this.subscriptionSectionActive() ? (
                    <img src="/images/sideways-arrow-white.svg" alt="open" />
                  ) : (
                    <img src="/images/sideways-arrow-gray.svg" alt="open" />
                  )}
                </MiniSection>
              </RelativeWrapper>
            )}
            <CustomerContext customerContext={this.props.selectedTicket?.moreTicketInfo?.customerContext} />

            <AlertCenterPanel />
          </CenterPanelWrapper>
          {this.renderInfoPanel()}
        </Container>
        {toolsMaskingActive && <CenterPanelFadeBackground onClick={() => this.handleCloseClick()} />}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  tagPathArray: extract.extractMacroWizardTagPathArray(state),
  currentlyStoredTag: extract.extractSimplrTagForSelectedTicket(state),
  customerName: extract.extractCustomerNameForSelectedTicket(state),
  mentionedOrders: extract.extractMLMentionedOrdersFromState(state),
  recentOrders: extract.extractRecentMLOrdersFromState(state),
  recentSubscriptions: extract.extractRecentSubscriptionsFromState(state),
  selectedTicketId: extract.extractSelectedTicketIdFromState(state),
  toolsMaskingActive: extract.toolsMaskingActive(state),
  infoPanelActive: extract.extractCenterPaneInfoPanelActiveFromState(state),
  selectedOrder: extract.extractCenterPaneSelectedOrderFromState(state),
  selectedSubscription: extract.extractCenterPaneSelectedSubscriptionFromState(state),
  showToolsActive: extract.getShowToolsState(state),
  mentionedOrderIds: extract.extractListOfMentionedOrderIdsFromState(state),
  orderingSystem: getOrderingSystem(state),
  partnerName: extract.getSmbOfSelectedTicket(state),
  brandName: extract.getBrandOfSelectedTicket(state),
  selectedTicket: extract.extractSelectedTicketFromState(state) || {},
  partnerInfo: extract.getPartnerInfoOfSelectedTicket(state),
  listType: extract.extractInfoPanelListTypeFromState(state),
  commerceWizardPath: extract.extractCommerceWizardPath(state),
  previouslyRecommendedProducts: extract.extractPreviouslyRecommendedProducts(state),
});

const mapDispatchToProps = {
  setCenterPaneInfoPanelActive: setCenterPaneExtraInfoPanelActive,
  setAlertManagerType,
  eraseRecommendationRegExFromTextInput,
  trackCommerceCloseWithNoRecommendations,
};

export default connect(mapStateToProps, mapDispatchToProps)(CenterInfoPanel);
